
import React, { useState } from 'react';
import { Button, Typography, Modal, Box, Divider, CircularProgress } from '@mui/material';
import Warning from '@mui/icons-material/Warning';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

export default function DeviceConnection({ handleNext, GetDeviceAsync, isConnected, handleRemoveESP32Settings, isConnecting, handleDeviceDisconnect }) {
  const [open, setOpen] = useState(false);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const handleApproveRemoveESP32Settings = () => {
    handleRemoveESP32Settings()
    handleClose()
  }

  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    textAlign: 'center',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    border: '1px solid #000',
    boxShadow: 24,
    p: 2,
  };

  return (
    <div>
      { !isConnected ? (
        <Box display="flex" flexDirection="column" alignItems="center" justifyContent="center" style={{ textAlign: 'center' }}>
          <Typography variant="h6" gutterBottom>
            기기 연결
          </Typography>
          { isConnecting ? (
            <>
              <CircularProgress />
              <Typography variant="body1" gutterBottom style={{ textAlign: 'center' }}>
                <br />
                연결 중...
              </Typography>
            </>
          ) : (
            <Typography variant="body1" gutterBottom style={{ textAlign: 'center' }}>
              <br />
              블루투스를 연결해서 기기를 설정할 수 있습니다.<br/>
              기기 연결 버튼을 눌러 LED Matrix 블루투스에 연결하세요.
            </Typography>
          )}
        </Box>
      ) : (
        <Box display="flex" flexDirection="column" alignItems="center" justifyContent="center" style={{ textAlign: 'center' }}>
          <CheckCircleIcon style={{ fontSize: 100, color: '#4caf50' }} />
          <Typography variant="h4" gutterBottom>
            기기에 연결되었습니다!
          </Typography>
        </Box>
      )}
      <Divider style={{ margin: '12px 0 12px 0' }} />
      <Button
        variant="contained"
        color="primary"
        onClick={handleNext}
        disabled={!isConnected}
        style={{ float: 'right' }}
      >
        다음
      </Button>
      <Button
        variant="outlined"
        color="secondary"
        onClick={handleOpen}
        disabled={!isConnected}
        style={{ float: 'right', margin: '0 8px' }}
      >
        기기 초기화
      </Button>

      { isConnected ? (
        <Button
          variant="outlined"
          color="secondary"
          onClick={handleDeviceDisconnect}
          style={{ float: 'left', margin: '0 8px' }}
        >
          연결 해제
        </Button>
      ) : (
        <Button
          variant="contained"
          color="primary"
          onClick={GetDeviceAsync}
          style={{ float: 'left' }}
        >
          기기 연결
        </Button>
      )}

      <Modal open={open} onClose={handleClose}>
        <Box sx={style}>
          <Warning style={{ fontSize: 100, color: '#ffef62' }} />
          <Typography variant="h6" style={{ marginTop: '8px', marginBottom: '8px' }}>
            기기의 모든 설정이 삭제됩니다.<br />
            정말 모든 설정을 삭제하시겠습니까?
          </Typography>
          <Button
            variant="outlined"
            color="secondary"
            onClick={handleClose}
            style={{ float: 'right', margin: '0 8px' }}
          >
            아니오
          </Button>
          <Button
            variant="contained"
            color="primary"
            onClick={handleApproveRemoveESP32Settings}
            style={{ float: 'right' }}
          >
            예
          </Button>
        </Box>
      </Modal>
    </div>
  );
}
